import {
  ApiError,
  AppSessionJwts,
  Message,
  SessionTokenData,
  ValidationTokenData,
} from '@mangovoice/types'

export interface ApiClientAuthData {
  validationToken: string | null
  accessToken: string | null
  refreshToken: string | null
  sessionToken: string | null
}

export enum AuthenticationType {
  GetAppSessionJwts = 'GET_APP_SESSION_JWTS',
  RefreshAppSessionJwts = 'REFRESH_APP_SESSION_JWTS',
  GetSession = 'GET_SESSION',
}

export interface AuthenticationResultCallbackData {
  authenticationType: AuthenticationType
  ok: boolean
  result:
    | ValidationTokenData
    | RefreshTokenResponse
    | AppSessionJwts
    | SessionTokenData
    | ApiError
    | Record<string, unknown>
}

export type GetAuthDataCallback = () => ApiClientAuthData

export type AuthenticationResultCallback = (
  data: AuthenticationResultCallbackData,
) => void

export interface PostMessageParams {
  threadId: number
  tempUuid: string
  body?: string
  file?: File
  onProgress?: (progress: number) => void
}

export interface CreateThreadResponse {
  id: number
  group_id: number
  name: string
  external_phone_number: string
  created_at: string
  updated_at: string
}

export type SendMessageResponse = Omit<Message, 'files'> & {
  file?: string
}

export type LoginByEmailPayload = {
  username: string
  password: string
}

export type LoginByEmailResponse = {
  access: string
  refresh: string
}

export type RefreshTokenResponse = {
  access: string
  refresh: string
}
